import { render, staticRenderFns } from "./chooseCurrency.vue?vue&type=template&id=2836d960&scoped=true&"
import script from "./chooseCurrency.vue?vue&type=script&lang=ts&"
export * from "./chooseCurrency.vue?vue&type=script&lang=ts&"
import style0 from "./chooseCurrency.vue?vue&type=style&index=0&id=2836d960&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2836d960",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VSelect,VTextField})
